import * as Sentry from '@sentry/react';

export const initializeSentry = () => {
  if (import.meta.env.MODE !== 'production') {
    return;
  }

  const dsn = import.meta.env.VITE_APP_SENTRY_DSN;
  const tenant = import.meta.env.VITE_APP_TENANT;
  const environmentName = import.meta.env.VITE_APP_ENVIRONMENT;
  const environment = `${tenant}-${environmentName}`;

  Sentry.init({
    dsn,
    environment,
    release: process.env.VITE_APP_VERSION,
    autoSessionTracking: false,
  });
};
